/**
 * @generated SignedSource<<dee5ad999cd0f51535dcea01b18510d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternAgreementsCard_brand$data = {
  readonly appleDeveloperAgreementsPendingSince: any | null;
  readonly id: string;
  readonly showIosTosAlert: boolean;
  readonly " $fragmentType": "InternAgreementsCard_brand";
};
export type InternAgreementsCard_brand$key = {
  readonly " $data"?: InternAgreementsCard_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternAgreementsCard_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternAgreementsCard_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appleDeveloperAgreementsPendingSince",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showIosTosAlert",
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "25a3c5eeec7358a1aef464ec9173a73a";

export default node;
